<template>
  <div class="min-h-screen relative">
   <!-- Background Image -->
   <div class="absolute inset-0 -z-10">
      <img
        src="@/assets/Order/OrderBackground.png"
        alt="Order Background"
        class="w-full h-full object-cover object-center"
      />
      <div class="absolute inset-0 bg-black/50"></div>
    </div>

    <!-- Main Content -->
    <div class="relative z-10 min-h-screen flex flex-col">
      <!-- Main Content Area -->
      <main class="flex-1 flex items-center justify-center px-4 py-20 mt-8">
        <!-- Empty Cart Modal -->
        <div class="bg-[#2A2A2A] rounded-2xl p-8 md:p-12 max-w-md w-full shadow-2xl border border-gray-700 mt-10">
          <!-- Icon -->
          <div class="flex justify-center mb-6">
            <div class="relative">
              <img src="@/assets/Order/no-order.png" alt="No Orders" class="w-32 h-32 mx-auto" style="object-fit: contain;" />
            </div>
          </div>

          <!-- Text Content -->
          <div class="text-center space-y-4">
            <!-- Heading -->
            <h3 class="text-white text-l font-['Great_Vibes'] font-regular" style="letter-spacing: 0.3em;">
              OH NO!
            </h3>
            <h1 class="text-[#F5BE32] text-2xl md:text-3xl font-['Cormorant_SC'] font-semibold">
              You Haven't Placed An Order Yet!
            </h1>
            
            <!-- Description -->
            <p class="text-white text-lg opacity-90">
              Please add items to your cart to start ordering!
            </p>
          </div>

          <!-- Button -->
          <div class="flex justify-center mt-8">
            <router-link
              to="/menu"
              class="bg-[#F5BE32] text-black font-['Cormorant_SC'] text-xl font-bold py-3 px-8 rounded-lg hover:bg-[#e6ac29] transition duration-300 shadow-lg hover:shadow-xl"
            >
              Go to Menu
            </router-link>
          </div>
        </div>
      </main>

    </div>
  </div>
</template>

<style scoped>
/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #1F1F1F;
}

::-webkit-scrollbar-thumb {
  background: #F5BE32;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #e6ac29;
}
</style> 